import { render, staticRenderFns } from "./Index copy.vue?vue&type=template&id=31d16f81&"
import script from "./Index copy.vue?vue&type=script&lang=js&"
export * from "./Index copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports